import { YStack, Text } from 'tamagui'
import type { SplitSlide as SplitSlideType } from '../../../content/decks/types'
import { SlideContainer, SlideInner, getAccentColor, parseLinkedText } from './shared'

export function SplitSlide({ slide }: { slide: SplitSlideType }) {
  const accentColor = getAccentColor(slide.accent)
  return (
    <SlideContainer>
      <SlideInner style={{ padding: 'clamp(32px, 6vw, 80px)' }}>
        <Text
          fontFamily="$heading"
          fontWeight="700"
          color={accentColor}
          style={{
            fontSize: 'clamp(24px, 4vw, 48px)',
            lineHeight: '1.2em',
          }}
        >
          {slide.headline}
        </Text>
        <Text
          fontFamily="$body"
          color="$textSecondary"
          style={{
            fontSize: 'clamp(14px, 1.8vw, 22px)',
            lineHeight: '1.6em',
            maxWidth: '800px',
          }}
        >
          {parseLinkedText(slide.body)}
        </Text>
      </SlideInner>
    </SlideContainer>
  )
}
